import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-page SEO. Updates <title>, <meta description>, OG tags & canonical.
 *
 * Usage:
 *   <SEO title="Shop" description="Order fresh meats..." path="/shop" />
 */
export default function SEO({ title, description, path = "/", image }) {
  const fullTitle = title?.includes("Arbe Minimart") ? title : `${title} | Arbe Minimart`;
  const url = `https://arbeminimart.com${path}`;
  const ogImage = image || "https://arbeminimart.com/assets/arbe-logo.png";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
